export component NotFound() {
	<head>
		<title>{"Not Found | ZagRipple"}</title>
	</head>

	<div class="flex flex-col items-center justify-center h-screen">{'Not Found'}</div>
}